import { axiosInstance } from '../../../../services/base';

export function getEmployeeLeaveReportSummary(filter) {
    const headers = { Authorization: `Bearer ${localStorage.getItem('auth_token')}` };
    return axiosInstance.get('/admin/leaves/summary', {
        params: { filter: filter },
        headers,
    });
}

export function getEmployeeUpcomingLeaves() {
    const headers = { Authorization: `Bearer ${localStorage.getItem('auth_token')}` };
    return axiosInstance.get('/admin/leaves/get-upcoming-leaves', {
        params: { filter: null },
        headers,
    });
}

export function getEmployeeLeaves(employeeId) {
    const headers = { Authorization: `Bearer ${localStorage.getItem('auth_token')}` };
    return axiosInstance.get(`/admin/leaves/get-employee-leaves/${employeeId}`, {
        params: {},
        headers,
    });
}

export function getAllEmployeeLeaves() {
    const headers = { Authorization: `Bearer ${localStorage.getItem('auth_token')}` };
    return axiosInstance.get('/admin/leaves/get-all-employee-leaves', {
        params: {},
        headers,
    });
}

export function getEmployeeConsumedLeaves() {
    const headers = { Authorization: `Bearer ${localStorage.getItem('auth_token')}` };
    return axiosInstance.get('/users/leaves/get-consumed-leaves', {
        params: {},
        headers,
    });
}

export function getIncomingLeaves() {
    const headers = { Authorization: `Bearer ${localStorage.getItem('auth_token')}` };
    return axiosInstance.get('/users/leaves/get-incoming-leaves', {
        params: {},
        headers,
    });
}
